// currently api dict response has the same labels for leave statuses with codes 4 and 6
// in order not to have lint error second label was changed a bit
// todo update labels when api will change response
export enum LeaveStatusCodes {
  OPEN = 1,
  AWAITING_APPROVAL = 2,
  AWAITING_APPROVAL_OF_PAYROLL_ADMIN = 3,
  AWAITING_APPROVAL_OF_HEAD_OF_HR = 4,
  LEAVE_APPROVED = 5,
  AWAITING_APPROVAL_OF_HEAD_OF_HR_DUPLICATE = 6,
  SALARY_PROCESSED = 7,
  CANCELLED = 8,
  REJECTED = 9,
  SALARY_READY = 10,
  TICKET_READY = 11,
  SALARY_AND_TICKET_READY = 12,
  AWAITING_APPROVAL_OF_ADMIN_MANAGER = 13,
}
